module.exports = __webpack_public_path__ + "img/logo-top-right-v2.81b1455b.png";